import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Standard } from '../../../models/standard.model';
import { AdminService } from '../../../services/admin.service';
import { Response } from '@angular/http';
import { UserService } from '../../../services/user.service';
import { ConfirmationPopupComponent } from '../view-group/popups/confirmation-popup/confirmation-popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Blank } from '../../../models/blank.model';
import { Question } from '../../../models/question.model';
import { NewBlank } from '../../../models/new-blank.model';
import { AddNewQuestionsComponent } from './popups/add-new-questions/add-new-questions.component';
import { EditStandardInfoComponent } from './popups/edit-standard-info/edit-standard-info.component';
import { FullUser } from '../../../models/full-user.model';
import { Status } from '../../../models/status.model';
import { Group } from '../../../models/group.model';
import { ApiConnectService } from '../../../services/api-connect.service';
import { ViewDocxService } from '../../../services/view-docx.service';
import { ViewDocxComponent } from '../view-docx/view-docx.component';
import { StepsControllerService } from "../../../services/steps-controller.service";
import { EditQuestionComponent } from '../../admin/create-operating-standard/opst-step-eight/edit-question-step-popup/edit-question.component';

@Component({
  selector: 'app-view-standard',
  templateUrl: './view-standard.component.html',
  styleUrls: ['./view-standard.component.css']
})

export class ViewStandardComponent implements OnInit, OnDestroy {
  standard: any;
  newBlanks: NewBlank[] = [];
  users: any;
  divisions: any;
  selectedUser: FullUser;
  selectedDivision: Group;

  selectedStatus: Status;

  isUploadDisabled = false;

  isNewStatus = false;
  isNewInitiator = false;
  isNewDivision = false;

  // RUS
  isNewRuDoc = false;
  isNewRuPpt = false;
  isNewRuPdf = false;
  fileRuDoc: File = null;
  fileRuPpt: File = null;
  fileRuPdf: File = null;
  // ENG
  isNewEnDoc = false;
  isNewEnPpt = false;
  isNewEnPdf = false;
  fileEnDoc: File = null;
  fileEnPpt: File = null;
  fileEnPdf: File = null;

  public isLoaded = false;
  public errorInfo = false;
  errorMessage = false;

  public isDeleted: boolean;
  deleteMessage: string;


  constructor(private route: ActivatedRoute,
    private adminService: AdminService,
    public userService: UserService,
    public viewDocxService: ViewDocxService,
    private modalService: NgbModal,
    private apiConnectService: ApiConnectService,
    public stepsControllerService: StepsControllerService) {
  }

  ngOnInit() {
    this.adminService.getStandard(this.route.snapshot.params['id']).subscribe(
      (response: any) => {
        this.errorMessage = false;
        if (response.status === 200) {
          this.standard = response.body;
          this.stepsControllerService.currentStandard = this.standard;

          this.isLoaded = true;
          this.errorInfo = false;
          this.selectedUser = this.standard.author;

          if (this.standard.hasOwnProperty('bindingGroup')) {
            this.selectedDivision = this.standard.bindingGroup;
          } else {
            this.standard.bindingGroup = null;
            this.selectedDivision = null;
          }

          this.selectedStatus = this.standard.status;
        }
      },
      () => {
        this.isLoaded = true;
        this.errorInfo = true;
      });

    this.adminService.getAllFullUsers().subscribe(
      (response: any) => {
        this.errorMessage = false;
        if (response.status === 200) {
          this.users = response.body;
        }
      },
      () => {
        this.errorMessage = true;
      });

    // Divisions
    this.adminService.getAllGroups().subscribe(
      (response: any) => {
        this.divisions = response.body;
      },
      () => {
      }
    );

  }

  ngOnDestroy() {
    if (localStorage.getItem('prevRoute').indexOf('/dashboard/standard') > -1 && localStorage.getItem('nextRoute').indexOf('/dashboard/create-operating-standard') === -1) {
      localStorage.removeItem('lastPage');
    }
    this.stepsControllerService.leaveComponent();
  }

  // Check if field has text
  hasText(text) {
    if (text !== null) {
      return text.trim().length > 0;
    } else {
      return false;
    }
  }

  selectStatus(status) {
    this.selectedStatus = status;
    if (status !== this.standard.status) {
      this.isNewStatus = true;
    } else {

      this.isNewStatus = false;
    }
  }

  selectUser(user: FullUser) {
    this.selectedUser = user;
    if (user.id !== this.standard.author.id) {
      this.isNewInitiator = true;
    } else {
      this.isNewInitiator = false;
    }
  }

  selectDivision(divis: Group) {
    this.selectedDivision = divis;
    if (this.standard.bindingGroup !== null) {
      if (divis.id !== this.standard.bindingGroup.id) {
        this.isNewDivision = true;
      } else {
        this.isNewDivision = false;
      }
    } else {
      this.isNewDivision = true;
    }
  }

  saveInitiator() {
    this.adminService.changeInitiator(this.standard, this.selectedUser).subscribe(
      (response: any) => {
        this.errorMessage = false;
        if (response.status === 200) {
          this.standard.author = this.selectedUser;
          this.isNewInitiator = false;
        }
      }, () => {
        this.errorMessage = true;
      }
    );
  }

  saveDivision() {
    this.adminService.changeDivision(this.standard, this.selectedDivision).subscribe(
      (response: any) => {
        this.errorMessage = false;
        if (response.status === 200) {
          this.standard.bindingGroup = this.selectedDivision;
          this.isNewDivision = false;
        }
      }, () => {
        this.errorMessage = true;
      }
    );
  }

  saveStatus() {
    this.adminService.changeStatus(this.standard, this.selectedStatus).subscribe(
      (response: any) => {
        this.errorMessage = false;
        if (response.status === 200) {
          this.standard.status = this.selectedStatus;
          this.isNewStatus = false;
        }
      }, () => {
        this.errorMessage = true;
      }
    );
  }

  openEditInfoModal() {
    const modalRef = this.modalService.open(EditStandardInfoComponent);
    modalRef.componentInstance.setStandard(this.standard);
  }

  openNewQuestionsModal() {
    const modalRef = this.modalService.open(AddNewQuestionsComponent);
    modalRef.componentInstance.setStandard(this.standard);
  }

  addNewBlank() {
    this.newBlanks.push(new NewBlank(null, null, null));
  }

  saveBlank(index) {
    if (this.newBlanks[index] != null) {
      this.adminService.uploadBlank(this.standard, [this.newBlanks[index]]).subscribe(
        (response: any) => {
          this.errorMessage = false;
          if (response.status === 200) {
            this.standard.blanks.push(response.body[0]);
            this.newBlanks.splice(index, 1);
          }
        }, () => {
          this.errorMessage = true;
        }
      );
    }
  }

  blanksChange(event, index: number) {
    const fileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      const formData = new FormData();
      formData.append('file', file, file.name);
      this.newBlanks[index].formData = formData;
    }
  }

  deleteBlank(key) {

    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'DYWTDTB';
    modalRef.result.then((result) => {
      if (result === 'ok') {
        // Delete;
        if (key > -1) {
          this.newBlanks.splice(key, 1);
        }
      }
    });
  }

  downloadFile(id) {
    this.isLoaded = false;
    this.userService.getFile(id).subscribe(
      (response: any) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.body);
        link.download = response.headers.get('filename');
        link.click();
        link.remove();
      },
      () => {
      }, () => {
        this.isLoaded = true;
      }
    );
  }


  fileChange(typeFile, event) {
    if (typeFile === 'RU_PPT') {
      if (event.target.files.length > 0) {
        this.fileRuPpt = event.target.files[0];
        this.isNewRuPpt = true;
      } else {
        this.fileRuPpt = null;
        this.isNewRuPpt = false;
      }
    }

    if (typeFile === 'RU_DOC') {
      if (event.target.files.length > 0) {
        this.fileRuDoc = event.target.files[0];
        this.isNewRuDoc = true;
      } else {
        this.fileRuDoc = null;
        this.isNewRuDoc = false;
      }
    }

    if (typeFile === 'RU_PDF') {
      if (event.target.files.length > 0) {
        this.fileRuPdf = event.target.files[0];
        this.isNewRuPdf = true;
      } else {
        this.fileRuPdf = null;
        this.isNewRuPdf = false;
      }
    }

    if (typeFile === 'EN_PPT') {
      if (event.target.files.length > 0) {
        this.fileEnPpt = event.target.files[0];
        this.isNewEnPpt = true;
      } else {
        this.fileEnPpt = null;
        this.isNewEnPpt = false;
      }
    }
    if (typeFile === 'EN_DOC') {
      if (event.target.files.length > 0) {
        this.fileEnDoc = event.target.files[0];
        this.isNewEnDoc = true;
      } else {
        this.fileEnDoc = null;
        this.isNewEnDoc = false;
      }
    }
    if (typeFile === 'EN_PDF') {
      if (event.target.files.length > 0) {
        this.fileEnPdf = event.target.files[0];
        this.isNewEnPdf = true;
      } else {
        this.fileEnPdf = null;
        this.isNewEnPdf = false;
      }
    }

  }

  openDocModalDOCX(fileLink) {

    localStorage.setItem('fileLink', fileLink);

    const modalRef = this.modalService.open(ViewDocxComponent, { size: 'lg', backdrop: 'static' });
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxIDManually();
      }
    }, () => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxIDManually();
    });

  }

  openDocModal(docxID, sID) {

    localStorage.setItem('DocxID', docxID);
    localStorage.setItem('DocxSID', sID);

    const modalRef = this.modalService.open(ViewDocxComponent, { size: 'lg', backdrop: 'static' });
    modalRef.result.then((result) => {
      if (result === 'Close') {
        // on close button
        this.viewDocxService.deleteLinkByDocxID();
      }
    }, () => {
      // on dismiss
      this.viewDocxService.deleteLinkByDocxID();
    });

  }

  deleteFileDOCX(sid, fileLink, type, docId) {
    this.adminService.deleteTempDocxFileManually(fileLink, sid).subscribe(
      (res: any) => {
        if (type === 'RU_DOC') {
          this.standard.ruDoc = null;
          this.standard.ruFileLink = null;
        } else if (type === 'EN_DOC') {
          this.standard.enDoc = null;
          this.standard.enFileLink = null;
        }

        // delete docID if exists
        if (docId) {
          this.deleteFile(docId, type);
        }

      },
      () => {
      }
    );
  }


  uploadFile(typeFile) {
    this.isUploadDisabled = true;
    if (typeFile === 'RU_PPT') {
      const formData: FormData = new FormData();
      formData.set(typeFile, this.fileRuPpt, this.fileRuPpt.name);
      this.adminService.uploadFiles(this.standard, formData).subscribe(
        (res: any) => {
          this.adminService.getStandard(this.standard.id).subscribe(
            (response: any) => {
              this.standard.ruPpt = response.body.ruPpt;
              this.isUploadDisabled = false;
            },
            (error) => {
              this.isUploadDisabled = false;
            }
          );
        }
      );
    }

    if (typeFile === 'RU_DOC') {
      const formData: FormData = new FormData();
      formData.set(typeFile, this.fileRuDoc, this.fileRuDoc.name);
      this.adminService.uploadFiles(this.standard, formData).subscribe(
        () => {
          this.adminService.getStandard(this.standard.id).subscribe(
            (response: any) => {
              this.standard.ruDoc = response.body.ruDoc;
              this.standard.ruFileLink = response.body.ruFileLink;
              this.standard.ruPdf = response.body.ruPdf;
              this.isUploadDisabled = false;
            },
            (error) => {
              this.isUploadDisabled = false;
            }
          );
        },
        (err) => {
          this.isUploadDisabled = false;
        }
      );
    }

    if (typeFile === 'EN_DOC') {
      const formData: FormData = new FormData();
      formData.set(typeFile, this.fileEnDoc, this.fileEnDoc.name);
      this.adminService.uploadFiles(this.standard, formData).subscribe(
        () => {
          this.adminService.getStandard(this.standard.id).subscribe(
            (response: any) => {
              this.standard.enDoc = response.body.enDoc;
              this.standard.enFileLink = response.body.enFileLink;
              this.standard.enPdf = response.body.enPdf;
              this.isUploadDisabled = false;
            },
            (error) => {
              this.isUploadDisabled = false;
            }
          );
        },
        (err) => {
          this.isUploadDisabled = false;
        }
      );
    }

    if (typeFile === 'RU_PDF') {
      const formData: FormData = new FormData();
      formData.set(typeFile, this.fileRuPdf, this.fileRuPdf.name);
      this.adminService.uploadFiles(this.standard, formData).subscribe(
        () => {
          this.adminService.getStandard(this.standard.id).subscribe(
            (response: any) => {
              this.standard.ruPdf = response.body.ruPdf;
              this.isUploadDisabled = false;
            },
            (error) => {
              this.isUploadDisabled = false;
            }
          );
        },
        (err) => {
          this.isUploadDisabled = false;
        }
      );
    }
    if (typeFile === 'EN_PDF') {
      const formData: FormData = new FormData();
      formData.set(typeFile, this.fileEnPdf, this.fileEnPdf.name);
      this.adminService.uploadFiles(this.standard, formData).subscribe(
        () => {
          this.adminService.getStandard(this.standard.id).subscribe(
            (response: any) => {
              this.standard.enPdf = response.body.enPdf;
              this.isUploadDisabled = false;
            },
            (error) => {
              this.isUploadDisabled = false;
            }
          );
        },
        (err) => {
          this.isUploadDisabled = false;
        }
      );
    }

    if (typeFile === 'EN_PPT') {
      const formData: FormData = new FormData();
      formData.set(typeFile, this.fileEnPpt, this.fileEnPpt.name);
      this.adminService.uploadFiles(this.standard, formData).subscribe(
        () => {
          this.adminService.getStandard(this.standard.id).subscribe(
            (response: any) => {
              this.standard.enPpt = response.body.enPpt;
              this.isUploadDisabled = false;
            },
            (error) => {
              this.isUploadDisabled = false;
            }
          );
        },
        (err) => {
          this.isUploadDisabled = false;
        }
      );
    }
  }

  openPdfStnd(fileId: string) {
    window.open(this.apiConnectService.getPdf + fileId, '_blank');
  }

  deleteFile(fileId: string, type: string) {
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'DO_YOU_WANT_TO_DELETE_THIS_STANDARD';
    modalRef.result.then((result) => {
      if (result === 'ok') {
        this.adminService.deleteFileFromStandard(fileId, type, this.standard).subscribe(
          (response: any) => {
            this.errorMessage = false;
            if (response.status === 200) {
              switch (type) {
                case 'RU_DOC': {
                  this.standard.ruDoc = null;
                  break;
                }
                case 'RU_PPT': {
                  this.standard.ruPpt = null;
                  break;
                }
                case 'RU_PDF': {
                  this.standard.ruPdf = null;
                  break;
                }
                case 'EN_DOC': {
                  this.standard.enDoc = null;
                  break;
                }
                case 'EN_PPT': {
                  this.standard.enPpt = null;
                  break;
                }
                case 'EN_PDF': {
                  this.standard.enPdf = null;
                  break;
                }
              }
            }
          },
          () => {
            this.errorMessage = true;
          }
        );
      }
    });
  }

  deleteBlankFile(blank) {
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'DYWTDTBF';
    modalRef.result.then((result) => {
      if (result === 'ok') {
        this.adminService.deleteBlankFromStandard(blank, this.standard).subscribe(
          (response: any) => {
            this.errorMessage = false;
            if (response.status === 200) {
              this.isDeleted = true;
              this.deleteMessage = 'Blank ' + blank.name + ' deleted successfully';

              const index = this.standard.blanks.indexOf(blank);
              this.standard.blanks.splice(index, 1);
            }
          },
          () => {
            this.errorMessage = true;
          }
        );
      }
    });
  }

  openEditQuestionModal(question: Question, lang: string) {
    const modalRef = this.modalService.open(EditQuestionComponent);
    modalRef.componentInstance.initParams(this.standard, question, lang);
  }

  deleteQuestion(question: Question, lang: string) {
    const modalRef = this.modalService.open(ConfirmationPopupComponent);
    modalRef.componentInstance.massage = 'DYWTDTQ';
    modalRef.result.then((result) => {
      if (result === 'ok') {
        this.errorMessage = false;
        this.adminService.deleteQuestionFromStandard(this.standard, question, lang).subscribe(
          (response: any) => {
            if (response.status === 200) {
              if (lang === 'RUSSIAN') {
                this.standard.russianQuestions.splice(
                  this.standard.russianQuestions.indexOf(question),
                  1
                );
              } else if (lang === 'ENGLISH') {
                this.standard.englishQuestions.splice(
                  this.standard.englishQuestions.indexOf(question),
                  1
                );
              }
            }
          }, () => {
            this.errorMessage = true;
          }
        );
      }
    });
  }

  filterBy(prop: string, list: string) {
    if (list === 'initiators') {
      if (this.users !== undefined) {
        return this.users.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
      }
    }
    if (list === 'departments') {
      if (this.divisions !== undefined) {
        return this.divisions.sort((a, b) => a[prop].toLowerCase() > b[prop].toLowerCase() ? 1 : a[prop].toLowerCase() === b[prop].toLowerCase() ? 0 : -1);
      }
    }
  }

}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/views/view-standard/view-standard.component.ts